import { recommendationUrlRedirect } from '@epicuro-next/state/recommendation-panels-state';
import { mapSearchResultsToProductData } from '../../helpers/map-search-results-to-product-data';
import { getPBasketSearchResultsStringProvider } from '../../product-basket';
import { RecommendedDataType } from '../../product-data';
import { getSquarePanelTemplate } from './square-panel-template';
import { eventHandlerFromAction } from '../../../utils/eventhandler-from-action';

export function createSquarePanelFromSearch() {
  const template = getSquarePanelTemplate('square-panel-root');

  template.root.data = {
    ...template.root.data,
    headerStyle: 'text-align: center;',
    panelName: 'square-panel-p-basket-search',
    panelStyle: 'SQMSE',
    searchUrl: '',
    seeMoreLinkFromMerchandiser: '',
    productsToLoad: 0,
    excludeProduct: 'undefined',
    shuffleResults: false,
    nrOfProductsToLoad: {
      values: [
        {
          provider: 'self',
          property: 'productsToLoad',
        },
        {
          provider: 'self',
          property: 'nrOfProductsToShow',
        },
      ],
      transform: function ([productsToLoad, nrOfProductsToShow]: [
        string,
        string,
      ]) {
        return productsToLoad || nrOfProductsToShow;
      }.toString(),
    },

    searchResults: getPBasketSearchResultsStringProvider({
      url: {
        provider: 'self',
        property: 'searchUrl',
      },
      nrOfProducts: {
        provider: 'self',
        property: 'nrOfProductsToLoad',
      },
    }),
    isLoading: {
      provider: 'id:square-panel-products-data-container',
      property: 'isLoading',
    },
    imgToUse: 'main',
    seeMoreLink: {
      values: [
        {
          provider: 'id:square-panel-root',
          property: 'seeMoreLinkFromMerchandiser',
        },
        {
          provider: 'id:square-panel-root',
          property: 'searchUrl',
        },
      ],
      transform: function ([seeMoreLinkFromMerchandiser, searchUrl]: [
        string,
        string,
      ]) {
        return seeMoreLinkFromMerchandiser.length
          ? seeMoreLinkFromMerchandiser
          : searchUrl;
      }.toString(),
    },
  };

  template.root.styles = {
    classes: ['row', 'h-100', 'align-content-start', 'pb-4'],
  };

  template.productDataContainer.data = {
    productData: {
      values: [
        {
          provider: 'parent',
          property: 'searchUrl',
        },
        {
          provider: 'parent',
          property: 'searchResults',
        },
        {
          provider: 'parent',
          property: 'nrOfProductsToShow',
        },
        {
          provider: 'parent',
          property: 'imgToUse',
        },
        {
          provider: 'parent',
          property: 'shuffleResults',
        },
        {
          provider: 'parent',
          property: 'excludeProduct',
        },
      ],
      transform: mapSearchResultsToProductData.toString(),
    },
    panelTrackingId: '',
    isLoading: {
      provider: 'self',
      property: 'productData',
      startWith: {
        value: 'isLoading',
      },
      transform: function (data: 'isLoading' | unknown[]): boolean {
        const isLoading = data === 'isLoading';
        return isLoading;
      }.toString(),
    },
    hasError: {
      provider: 'self',
      property: 'productData',
      transform: function (productData: unknown): boolean {
        return (
          productData === undefined ||
          window.neoclesDynamicFramework.recommendationsPanels.methods.isResolveValueError(
            productData,
          )
        );
      }.toString(),
    },
    hasData: {
      values: [
        { provider: 'self', property: 'productData' },
        { provider: 'self', property: 'hasError' },
      ],
      transform: function ([productData, hasErrorArg]: [
        unknown[],
        boolean,
      ]): boolean {
        if (hasErrorArg) {
          return false;
        }

        return productData && productData.length > 0;
      }.toString(),
      startWith: {
        value: [undefined, false],
      },
    },
    hasItems: template.productDataContainer.data.hasItems,
    panelName: 'square-panel-from-search',
    panelStyle: 'panel-style-not-configured-yet',
  };

  template.seeMoreLink.inputs.routerLink =
    null as unknown as typeof template.seeMoreLink.inputs.routerLink;
  template.seeMoreLink.styles.classes = [
    ...template.seeMoreLink.styles.classes,
    'cursor-pointer',
  ];

  template.seeMoreLink.eventHandlers = {
    onClick: [
      eventHandlerFromAction(recommendationUrlRedirect, {
        id: 'recommendation-search-see-more-click',
        payload$: {
          values: [
            {
              provider: 'id:square-panel-root',
              property: 'panelName',
            },
            {
              provider: 'id:square-panel-root',
              property: 'seeMoreLink',
            },
            {
              provider: 'id:square-panel-products-data-container',
              property: 'panelTrackingId',
            },
          ],
          transform: function ([panelName, routerLink, panelStyle]: [
            string,
            string,
            string,
            RecommendedDataType,
          ]) {
            return {
              panelName,
              routerLink,
              panelStyle,
              providerId: 'ProductSearch',
              seeMore: true,
            };
          }.toString(),
        },
      }),
    ],
  };

  return template;
}

export const squarePanelFromSearch = createSquarePanelFromSearch().styleWrapper;
